import logo from '../images/common/logo.svg'
import preview from '../images/common/preview.svg'

import email from '../images/particals/footer/email.svg'
import location from '../images/particals/footer/location.svg'
import phone from '../images/particals/footer/phone.svg'

import success from '../images/particals/feedback/success.svg'

import menu from '../images/particals/header/menu.svg'
import close from '../images/particals/header/close.svg'

const images = {
  logo,
  email,
  location,
  phone,
  preview,
  success,
  menu,
  close
}

export default images